// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as ShoppingCartActions } from '../duck';
import ShoppingCartMenu from '../components/ShoppingCartMenu';
import { push } from 'react-router-redux';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    shoppingCart: state.shoppingCart.shoppingCart,
    virtualShoppingCart: state.shoppingCart.virtualShoppingCart,
    isFetchingCart: state.shoppingCart.isFetchingCart,
    fetchCartError: state.shoppingCart.fetchCartError,
    isDeletingItem: state.shoppingCart.isDeletingItem,
    deleteItemError: state.shoppingCart.deleteItemError,
    locale: state.locale,
    localValues: state.localValues,
    authenticated: state.auth.authenticated,
    user: state.auth.user,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...ShoppingCartActions,
    goToRedirect: (route) => push(route)
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCartMenu);



// WEBPACK FOOTER //
// ./src/modules/shopping-cart/containers/ShoppingCartMenuContainer.js